module.exports = __webpack_public_path__ + "img/nissin-5.40c60aa9.jpg";